import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Notification } from 'sharedComponents';
import { clearNotification } from '../../actions';

const notificationsSelector = (state) => state.notifications;

const NotificationWrapper = () => {
  const dispatch = useDispatch();
  const notificationState = useSelector(notificationsSelector);
  const notification = notificationState[0] || {};

  const onRemoveNotification = (id) => dispatch(clearNotification(id));

  return <Notification notification={notification} clearNotification={onRemoveNotification} />;
};

export default NotificationWrapper;
